import { configureStore } from "@reduxjs/toolkit";
import usersReducer from "./reducers/usersReducer";
import ordersReducer from "./reducers/ordersReducer";
import devicesReducer from "./reducers/devicesReducer";
import suppliersReducer from "./reducers/suppliersReducer";
import organismsReducer from "./reducers/organismsReducer";
import filtersReducer from "./reducers/filtersReducer";

export const store = configureStore({
  reducer: {
    users: usersReducer,
    orders: ordersReducer,
    devices: devicesReducer,
    suppliers: suppliersReducer,
    organisms: organismsReducer,
    filters: filtersReducer,
  },
});
